import axios from "./index";

class search {
  //get||post
  static searchOrder(params) {
    return axios.post("/open-planes/detr/ticketCheck", params);
  }
}

export default search;
